import { Environment } from '@models';
import { environment as rootEnvironment } from '../../../../environments/environment.development';

export const environment: Environment = {
  ...rootEnvironment,
  googleMapsApiKey: 'AIzaSyANmnAElEXRGvXqPa3uiL__jYTO3ZxtpP8',
  providerPortalUrl: 'https://provider.dev.icaredx.app',
};
